import React from 'react'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { format } from 'date-fns'
import times from 'lodash/times'
import truncate from 'lodash/truncate'
import capitalize from 'lodash/capitalize'
import { Avatar } from '@deal/components'
import { DepartmentExpertReviewFragment } from '#src/generated/graphql'
import StarIcon from '../star-rate.svg'
import styles from './styles.css'

interface Props {
  departmentSlug: string
  review: DepartmentExpertReviewFragment
}

const ReviewCard: React.SFC<Props> = ({ review, departmentSlug }) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.reviewCard}>
        <div className={styles.reviewHeader}>
          <div className={styles.reviewHeaderContent}>
            <Avatar
              name={`${review.expert.firstName} ${review.expert.lastName}`}
              src={
                review.expert.expertProfile && review.expert.expertProfile.profilePhoto
                  ? review.expert.expertProfile.profilePhoto.url
                  : undefined
              }
            />
            <div className={styles.reviewHeaderText}>
              <strong>
                {review.expert.firstName && capitalize(review.expert.firstName)}{' '}
                {review.expert.lastName && capitalize(review.expert.lastName)}
              </strong>{' '}
              recieved a new{' '}
              <div>
                review from{' '}
                <strong>
                  {review.consumer.firstName && capitalize(review.consumer.firstName)}
                </strong>{' '}
                on {format(review.reviewedAt, 'MMM d, YYYY')}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.reviewBody}>
          <div>
            {times(Math.round(review.rating)).map(index => (
              <StarIcon key={index} className={styles.smallRatingStar} />
            ))}
          </div>
          {review.headline && <div className={styles.reviewBodyHeader}>{review.headline}</div>}
          {review.comments && (
            <div>
              <ReactMarkdown
                source={truncate(review.comments, {
                  length: 250
                })}
                className={styles.reviewComments}
              />
              {review.comments.length >= 225 && (
                <Link to={`/reviews/${departmentSlug}`} className={styles.readMore}>
                  Read More
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ReviewCard
